import React from "react";
import _ from "lodash";
import { Button, Box } from "@showitinc/showit-wc";

import Modal from "./base/Modal";
import ButtonBar from "./base/ButtonBar";
import uiPrefix from "../utils/UiPrefixUtils";

const InfoMessageModal = ({
  title = "Info",
  message = "",
  closeButtonText = "Close",
  closeButtonAction,
  actionButtonAction,
  actionButtonText = "OK",
  ...props
}) => {
  const _close = () => {
    if (closeButtonAction) {
      closeButtonAction();
    }
  };

  const _action = () => {
    if (actionButtonAction) {
      actionButtonAction();
    }
  };

  const modalProps = _.pick(props, Modal.BASIC_PROPS);
  const showHeaderCloseButton = true;

  return (
    <Modal {...modalProps}>
      <Modal.Dialog>
        <Modal.Dialog.Header closeButton={showHeaderCloseButton}>
          <Modal.Dialog.Title>{title}</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body>
          <div style={{ textAlign: "center" }}>{message}</div>
        </Modal.Dialog.Body>
        <Modal.Dialog.Footer>
          <ButtonBar>
            <Box mr="3">
              <Button
                variant="minimal"
                data-e2e={uiPrefix("modal-close-btn")}
                className={uiPrefix("modal-close-btn")}
                onClick={_close}
              >
                {closeButtonText}
              </Button>
            </Box>
            <Button
              variant="feature"
              data-e2e={uiPrefix("modal-action-btn")}
              className={uiPrefix("modal-action-btn")}
              onClick={_action}
            >
              {actionButtonText}
            </Button>
          </ButtonBar>
        </Modal.Dialog.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default InfoMessageModal;
